// @ts-check
import React from 'react';
import ContentPageContext from "@/src/cms/context/ContentPageContext";
import Sanitize from "@/src/shared/components/Sanitize";
import { Skeleton } from "antd";
import { css, jsx } from '@emotion/core';
import { useContext } from "react";
import contentStyle from '@/src/cms/contentStyle';

const style = {
  body: [
    contentStyle,
    css`
      padding: 52px 32px;
      background-color: white;
    `,
  ]
}

/** 
 * @param {{
 *   before?: import("react").ReactNode;
 *   after?: import("react").ReactNode;
 *   bodyStyle?: any;
 * }} props 
 */
export default function ContentBody(props) {
  const { before, after, bodyStyle } = props;
  const value = useContext(ContentPageContext);

  if (!value) {
    throw new Error('ContentBody must be wrapped with ContentPageContext.Provider or ContentPageContextProvider')
  }

  if (!value.body) return null;

  return (
    <main css={[style.body, bodyStyle]}>
      {before}
      {value.loading 
        ? <Skeleton paragraph={{ rows: 12 }} active /> 
        : <Sanitize mildwest>{value.body}</Sanitize>
      }
      {after}
    </main>
  )
}